import { format } from 'date-fns'
import { money } from "./money"

/**
 * Formats a given string to sentence case
 */
export const formatString = (str) => {
  if (!str) return ''
  const words = str.split('_')
  const sentence = words.join(' ')
  return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase()
}

/**
 * Formats a given date object to readable string
 */
export const formatDate = (date) => {
  return format(date, 'MM/dd/yyyy')
}

/**
 * Formats a given number according to the specified locale and decimal places.
 */
export const formatNumber = (number, { decimals = 0, showDecimalOnZero = true, locale = 'en-US' } = {}) => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: showDecimalOnZero ? decimals : 0,
    maximumFractionDigits: decimals,
  }).format(number)
}

/**
 * Formats a given amount into a currency string based on specified locale and currency.
 */
export const formatCurrency = (amount, { fromCents = false, decimals = 2, currency = 'USD', locale = 'en-US' } = {}) => {
  const value = fromCents ? money.fromCents(amount) : amount

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    style: 'currency',
    currency,
  }).format(value)
}

/**
 * Formats a given phone number to (000) 000-0000
 */
export const formatPhoneNumber = (number) => {
  // remove everything except digits
  let digits = number.replace(/\D/g, '')

  // remove leading country code (1)
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1)
  }

  // must be exactly 10 digits now
  if (digits.length !== 10) return digits

  const area = digits.slice(0, 3)
  const mid = digits.slice(3, 6)
  const last = digits.slice(6)

  return `(${area}) ${mid}-${last}`
}

/**
 * Formats a given address to array
 */
export const formatAddress = (address = {}) => {
  if (!address || typeof address !== 'object') return []

  const {
    company,
    address1,
    address2,
    city,
    province,
    zip,
    phone,
  } = address

  const formatted = []

  if (company?.trim()) formatted.push(company.trim())
  if (address1?.trim()) formatted.push(address1.trim())
  if (address2?.trim()) formatted.push(address2.trim())

  // City, Province ZIP
  if (city || province || zip) {
    const cityLine = [
      city?.trim(),
      [province?.trim(), zip?.trim()].filter(Boolean).join(' ')
    ]
      .filter(Boolean)
      .join(', ')

    formatted.push(cityLine)
  }

  if (phone?.trim()) {
    const formattedPhone = formatPhoneNumber(phone)
    if (formattedPhone) formatted.push(formattedPhone)
  }

  return formatted
}